import { ComponentType, lazy, Suspense } from 'react';

export const withSuspense = (Component: React.LazyExoticComponent<ComponentType>) => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component />
    </Suspense>
  );
};

export const lazyLoad = <T extends ComponentType<any>>(component: T) => {
  return lazy(() => {
    return new Promise<{ default: T }>((resolve) => {
      resolve({ default: component });
    });
  });
};

export const PageLoader = () => (
  <div className="flex items-center justify-center w-full h-[50vh]">
    <div className="relative">
      <div className="w-12 h-12 rounded-full border-4 border-gray-200" />
      <div className="w-12 h-12 rounded-full border-4 border-blue-500 border-t-transparent animate-spin absolute top-0" />
    </div>
  </div>
);
